/* eslint-disable no-unused-vars */
import { NUMBER } from "../../../constants/app-constants";
import { carConsumerService } from "../../../service/car-consumer-gateway-api";
import { CarService } from "../../../service/car-service";
import { LeadServiceJava } from "../../../service/lead-service-java-api";
import { VehicleService } from "../../../service/vehicle-service";
import { fetchDataSuccess, fetchDataFailure } from "../lead-brands/actions";
import { setDetails } from "../pre-delivery-inspection-lead-form-parent/actions";
import Types from "./types";
import { AuthService } from "../../../service/auth-service";
import queryString from "querystring";
import parsePdiCancellationReasons from "../../../utils/parsers/parse-pdi-cancellation-reasons";
import { parseNewCmsData } from "../../../utils/helpers/new-cms-data-parser";
import parsePdiConfirmationDetails from "../../../utils/parsers/parse-pdi-confirmation-details";
import { getParsedIntentData } from "../../shared/pre-delivery-inspection-confirmation-status/selector";
import { PdiCmsService } from "../../../service/pdi-cms-service";
import { parsePdiCmsData } from "../../../utils/helpers/pdi-cms-data-parser";
import { VasBffService } from "../../../service/vas-bff-service";

const setSsrStatus = (isSsr) => ({
    type: Types.SET_SSR_STATUS,
    isSsr
});

const fetchBrands = () => (dispatch) => {
    return new Promise((resolve, reject) => {
        CarService.fetchBrands()
            .then((response) => {
                dispatch(fetchDataSuccess(response));
                resolve();
            })
            .catch((error) => {
                dispatch(fetchDataFailure(error));
                reject(error);
            });
    });
};

const setData = (data) => ({
    type: Types.SET_DETAILS,
    data
});

const getPdiPriceDetails = () => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.getPdiPriceDetails()
            .then((response) => {
                resolve(response.data);
            }).catch((error) => {
                reject(error);
            });
    });
};

const getLandingPageData = () => (dispatch) => {
    return new Promise((resolve, reject) => {
        PdiCmsService.getPdiData()
            .then(res => {
                getPdiPriceDetails().then((priceDetails) => {
                    const data = res.data.data || {};
                    const parsedData = parseNewCmsData({
                        data: {
                            ...data,
                            carTypeList: getParsedIntentData(priceDetails, data || {})
                        }
                    });
                    dispatch(setData({cmsDetails: parsedData.cmsData}));
                    resolve(parsedData);
                }).catch((e) => reject(e));
            })
            .catch(error => {
                reject(error);
            });
    });
};

const createPDILead = ({ payload, secureToken }) => (dispatch) => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.createPDILead({ payload, secureToken })
            .then((response) => {
                dispatch(setDetails({
                    registrationNumber: null,
                    token: response.data.detail.token
                }));
                resolve(response.data.detail.token);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

const getVehicleDetail = (registrationNumber) => dispatch => {
    return new Promise((resolve, reject) => {
        CarService.vehicleNoRegistration(registrationNumber, { origin_source: "c2b-website" })
            .then(response => {
                const data = response.data.detail;
                const { brand = {}, model = {}, rc_owner_name_masked: ownerName = "" } = data || {};
                dispatch(setDetails({
                    brand: { id: brand.make_id || "", name: brand.make_display || "" },
                    model: { id: model.model_id || "", name: model.model_display || "" },
                    registrationNumber,
                    ownerName: ownerName || "",
                    activeAccordionStepIndex: model.model_id ? NUMBER.ONE : NUMBER.ZERO
                }));
                resolve({
                    redirectToDetails: brand.make_id && model.model_id
                });
            })
            .catch(() => {
                dispatch(setDetails({
                    brand: {},
                    model: {},
                    ownerName: "",
                    registrationNumber,
                    activeAccordionStepIndex: NUMBER.ZERO
                }));
                resolve({
                    redirectToDetails: false
                });
            });
    });
};

const fetchLeadDetails = (token, params, secureToken) => (dispatch) => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.fetchLeadDetails(token, params, false, secureToken).then(response => {
            const data = response.data.detail;
            resolve({
                ...data,
                ...(data && data.moreDetails && data.moreDetails.geoData || {})
            });
        }).catch(error => {
            reject(error);
        });
    });
};

const createOrderPrePurchase = (payload) => dispatch => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.createOrderPrePurchase({ payload, isDesktop: true }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
};

const fetchConfirmationDetails = (token, secureToken) => dispatch => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.getAppointmentDetailsByToken(token, secureToken)
            .then(response => {
                resolve(parsePdiConfirmationDetails(response));
            })
            .catch(error => {
                reject(error);
            });
    });
};

const getOrderDetails = (details) => dispatch => {
    return new Promise((resolve, reject) => {
        carConsumerService.getOrderDetails(details)
            .then(response => {
                resolve({
                    ...(response.data.orderItems && response.data.orderItems[NUMBER.ZERO]),
                    paddedOrderId: response.data.paddedOrderId,
                    invoiceAvailable: response.data.invoiceAvailable,
                    orderNumber: response.data.orderNumber
                });
            })
            .catch(error => {
                reject(error);
            });
    });
};

const fetchSlots = (params) => dispatch => {
    return new Promise((resolve, reject) => {
        carConsumerService.fetchGeoSlots(params).then(response => {
            resolve(response);
        }).catch((error) => {
            reject(error);
        });
    });
};

const createAppointment = (token, params, query) => dispatch => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.createAppointment(token, params, query).then(response => {
            resolve(response.data.detail);
        }).catch((error) => {
            reject(error);
        });
    });
};

const updateAppointment = (token, params, query) => dispatch => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.updateAppointment(token, params, query).then(response => {
            resolve(response.data.detail);
        }).catch((error) => {
            reject(error);
        });
    });
};

const rescheduleAppointment = (token, params) => dispatch => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.rescheduleAppointment(token, params)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const getPreDeliveryInspectionPrice = ({ newCarsPdiLead = false }) => (dispatch) => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.getPreDeliveryInspectionPrice({ newCarsPdiLead })
            .then((response) => {
                resolve(response.data);
            }).catch((error) => {
                reject(error);
            });
    });
};

const confirmCancelAppoiment = (token, payload) => dispatch => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.confirmCancelAppoiment(token, payload)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const getAppointmentCancelReasons = () => dispatch => {
    return new Promise((resolve, reject) => {
        VehicleService.getQuestionForUserIntent("pdi_appointment_cancel")
            .then(response => {
                resolve(parsePdiCancellationReasons(response, true));
            })
            .catch(error => {
                reject(error);
            });
    });
};

const fetchCjDetail = (appointmentId) => dispatch => {
    return new Promise((resolve, reject) => {
        carConsumerService.fetchCjDetails(appointmentId)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const updateGeoDetailsInLead = (payload, token) => dispatch => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.updateGeoDetailsInLead(payload, token).then(response => {
            resolve(response.data.detail);
        }).catch(error => {
            reject(error);
        });
    });
};

const updatePDILead = (payload) => (dispatch) => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.updatePDILead(payload)
            .then((response) => {
                dispatch(setDetails({
                    registrationNumber: null,
                    token: response.data.detail.token
                }));
                resolve(response.data.detail.token);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

const updateLead = (query, params) => (dispatch) => {
    const stringifiedQuery = queryString.stringify(query);
    return new Promise((resolve, reject) => {
        LeadServiceJava.updateLead(stringifiedQuery, params).then(response => {
            resolve(response.data.detail);
        }).catch(error => {
            reject(error);
        });
    });
};

const sendOTP = (mobile) => (dispatch) => {
    return new Promise((resolve, reject) => {
        AuthService.sendOTP(mobile, "")
            .then(response => resolve(response))
            .catch(error => reject(error));
    });
};

const checkPdiEligibility = (payload) => (dispatch) => {
    return new Promise((resolve, reject) => {
        carConsumerService.checkPdiEligibility(payload)
            .then(response => resolve(response.data))
            .catch(error => reject(error));
    });
};

const getPdiCityData = city => {
    return new Promise((resolve, reject) => {
        VasBffService.getPdiCityData(city)
            .then(response => {
                resolve(response.data.data);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const getPdiPageData = city => dispatch => {
    return new Promise(async (resolve, reject) => {
        try {
            const [pdiData, vasPdiData] = await Promise.all([
                getPdiPriceDetails(),
                getPdiCityData(city)
            ]);

            const { cmsData: data } = vasPdiData;
            const { cmsData: cmsDetails } = parsePdiCmsData({
                data: {
                    ...data?.data,
                    carTypeList: getParsedIntentData(pdiData, data?.data || {})
                }
            });
            dispatch(setData({ cmsDetails }));
            resolve(cmsDetails);
        } catch (e) {
            reject(e);
        }
    });
};

export {
    fetchBrands,
    createPDILead,
    fetchLeadDetails,
    createOrderPrePurchase,
    getVehicleDetail,
    fetchConfirmationDetails,
    getOrderDetails,
    fetchSlots,
    createAppointment,
    updateAppointment,
    rescheduleAppointment,
    getPreDeliveryInspectionPrice,
    confirmCancelAppoiment,
    getAppointmentCancelReasons,
    fetchCjDetail,
    updateGeoDetailsInLead,
    getLandingPageData,
    setSsrStatus,
    updatePDILead,
    updateLead,
    sendOTP,
    setData,
    checkPdiEligibility,
    getPdiPageData
};
